import { render, staticRenderFns } from "./NewLabelGeneratorChooser.vue?vue&type=template&id=1a39d757&"
import script from "./NewLabelGeneratorChooser.vue?vue&type=script&lang=ts&"
export * from "./NewLabelGeneratorChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports